document.addEventListener("DOMContentLoaded", function() {
  
  function setActiveState() {
    // Check the active slider-counter__link
    var activeSlider = document.querySelector(".slider-counter__link.slider-counter__link--active");
    if (activeSlider) {
      var index = [...activeSlider.parentNode.children].indexOf(activeSlider);
      
      // Reset all guts divs
      var mobileGutsElements = document.querySelectorAll('#dialog-m > .frame > .guts');
      var desktopGutsElements = document.querySelectorAll('#dialog-d > .guts');
      var allGutsElements = [...mobileGutsElements, ...desktopGutsElements];

      allGutsElements.forEach(function(guts) {
        guts.classList.remove("active-character");
      });
      
      // Set active state for the corresponding guts element
      if(mobileGutsElements[index]) {
        mobileGutsElements[index].classList.add("active-character");
      }
      if(desktopGutsElements[index]) {
        desktopGutsElements[index].classList.add("active-character");
      }
    }
}
  
  // Function to handle mutations
  function handleMutations(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.attributeName === "class") {
        setActiveState();
      }
    });
  }

  // Target the elements to observe
  var targets = document.querySelectorAll(".slider-counter__link");
  
  // Create an observer instance with the callback
  var observer = new MutationObserver(handleMutations);
  
  // Options for the observer (which mutations to observe)
  var config = { attributes: true, childList: false, characterData: false };
  
  // Start observing the target nodes for configured mutations
  targets.forEach(function(target) {
    observer.observe(target, config);
  });

  // Handle window resize
  window.addEventListener('resize', function() {
    setActiveState();
  });

});
function adjustFrameHeight() {
  // Check if browser width is under 450px
  if (window.innerWidth < 450) {
      var avyBlurbs = document.getElementsByClassName('mblrb');
      var maxHeight = 0;

      // Convert HTMLCollection to Array and determine the height of the tallest .avy-blurb
      Array.from(avyBlurbs).forEach(function(avyBlurb) {
          var height = avyBlurb.offsetHeight;
          if (height > maxHeight) {
              maxHeight = height;
          }
      });

      // Set the min-height of the .frame element
      var frameElement = document.querySelector('.frame');
      if (frameElement) {
          frameElement.style.minHeight = (maxHeight + 100) + 'px';
      }
  } else {
      // Reset the min-height if browser width is 450px or more
      var frameElement = document.querySelector('.frame');
      if (frameElement) {
          frameElement.style.minHeight = '';
      }
  }
}

// Run the function initially
adjustFrameHeight();

// Add event listener to the window resize event
window.addEventListener('resize', adjustFrameHeight);
